import { render } from "./phoneCalls.vue?vue&type=template&id=5e69ebf6"
import script from "./phoneCalls.vue?vue&type=script&lang=js"
export * from "./phoneCalls.vue?vue&type=script&lang=js"

import "./phoneCalls.vue?vue&type=style&index=0&id=5e69ebf6&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__